if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        // ここをコメントアウトすると「カートに追加」ボタンを押下するとカート画面に遷移する
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {


        //giftoption設定
        //現在の要素から最も近いproduct-info要素を見つける
        // let currentElement = this;
        // let productInfoElement = currentElement.closest("product-info");

        // productInfoElement内のjs_gift_option input要素を見つける
        // let giftOptionInput = productInfoElement.querySelector(".js_gift_option input");


        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
          console.log("pop");


        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {


              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;



              return;
            } else if (!this.cart) {

              console.log("go");
              window.location = window.routes.cart_url;

              // if(giftOptionInput) {
              //   if (giftOptionInput.checked) {
              //       // チェックされている場合の処理
              //       console.log("Checked");
  
              //       const formData = {
              //         items: [
              //           {
              //             id: 45300880539870,
              //             quantity: 1,
              //             properties: {
              //             }
              //           }
              //         ]
              //       };
  
              //       fetch('/cart/add.js', {
              //         method: 'POST',
              //         headers: {
              //           'Content-Type': 'application/json'
              //         },
              //         body: JSON.stringify(formData)
              //       })
              //       .then(response => {
              //         if (response.ok) {
              //           window.location = window.routes.cart_url;
              //         } else {
              //           return Promise.reject('Fetch failed');
              //         }
              //       })
              //       .catch(error => {
              //         console.error('Error:', error);
              //       });
  
  
              //   } else {
              //       // チェックされていない場合の処理
              //       console.log("Not Checked");
              //       window.location = window.routes.cart_url;
              //   }
              // } else {
              //   window.location = window.routes.cart_url;
              // }

        
        
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            
            // if (giftOptionInput.checked) {
            //   // チェックされている場合の処理
            //   console.log("Checked");
  
            //   const formData = {
            //     items: [
            //       {
            //         id: 45300880539870,
            //         quantity: 1,
            //         properties: {
            //         }
            //       }
            //     ]
            //   };
  
            //   fetch('/cart/add.js', {
            //     method: 'POST',
            //     headers: {
            //       'Content-Type': 'application/json'
            //     },
            //     body: JSON.stringify(formData)
            //   })
            //   .then(response => {
            //     if (response.ok) {
            //     } else {
            //       return Promise.reject('Fetch failed');
            //     }
            //   })
            //   .catch(error => {
            //     console.error('Error:', error);
            //   });
  
            // } else {
            //     // チェックされていない場合の処理
            //     console.log("Not Checked");
            // }


          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
